module.exports = require("pdfjs-dist/build/pdf.worker.min.mjs");